<script lang="ts">
	interface Props {
		currentUser?: string
		onlogoutClicked?: (() => void) | null
	}

	let { currentUser = '', onlogoutClicked = null }: Props = $props()

	const logout = () => {
		onlogoutClicked?.()
	}
</script>

<div class="header">
	<div class="welcome">
		<p>Welcome {currentUser}</p>
		<button class="logout-button" onclick={logout}>Logout</button>
	</div>
</div>

<style>
	.header {
		@apply flex justify-between items-center p-4 bg-gray-100 border-b border-gray-300;
	}

	.welcome {
		@apply flex items-center;
	}

	.logout-button {
		@apply ml-4 bg-red-500 text-white py-2 px-4 rounded;
	}
</style>
